import React, { Component, Suspense } from "react";
import Map from "./editor-map";
import classNames from "classnames";
import { Redirect } from "react-router-dom";
import store from "store";
import EditorSidebar from "./editor-sidebar";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import i18n from "i18next";

class EditorComponent extends Component {
  static whyDidYouRender = true;

  constructor(props) {
    super(props);
    this._map = React.createRef();

    const { t } = props;

    let style = "simple_black";
    let size = {
      selectedSizeId: "50х70 см",
      ratio: "5-7",
      printWidth: 500,
      printHeight: 700,
    };

    const queryParams = queryString.parse(props.location.search);
    if (queryParams) {
      if (queryParams.style) {
        style = queryParams.style;
      }
      if (queryParams.size) {
        console.log("size:", queryParams.size);
        switch (queryParams.size) {
          case "30":
            size = {
              selectedSizeId: "30х40 см",
              ratio: "3-4",
              printWidth: 300,
              printHeight: 400,
            };
            break;
          case "40":
            size = {
              selectedSizeId: "40х50 см",
              ratio: "4-5",
              printWidth: 400,
              printHeight: 500,
            };
            break;
          case "50":
            size = {
              selectedSizeId: "50х70 см",
              ratio: "5-7",
              printWidth: 500,
              printHeight: 700,
            };
            break;
          case "70":
            size = {
              selectedSizeId: "70х100 см",
              ratio: "7-10",
              printWidth: 700,
              printHeight: 1000,
            };
            break;
        }
      }
    }
    var state = {
      redirect: null,
      isSmallScreen: true,

      text1: t(""),
      text2: t(""),
      price: 0,
      selectedMaterialId: "Бумага",
      selectedHangerId: "Нет",
      selectedMaterialName: "Папір",
      selectedHangerName: "Немає",
      selectedStyleId: style,
      ...size,
    };

    try {
      var editorStateDateString = store.get("audioEditorStateDate");
      if (editorStateDateString) {
        var editorStateDate = new Date(editorStateDateString);
        //addDays(1)
        editorStateDate.setDate(editorStateDate.getDate() + 1);
        if (new Date() < editorStateDate) {
          console.log("restoring state...");
          var restoredState = store.get("audioEditorState");
          if (restoredState) {
            restoredState.date = new Date(restoredState.date);

            state = { ...state, ...restoredState };
            console.log("state restored");
          }
        }
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }

    state.initialSelectedMaterialId = state.selectedMaterialId;
    state.initialSelectedSizeId = state.selectedSizeId;
    state.initialSelectedHangerId = state.selectedHangerId;
    this.state = state;
    //console.log(this.state);
  }

  componentDidMount() {
    try {
      var host = window.location.hostname;
      if (!host.startsWith("localhost")) {
        window.fbq("trackSingle", "832974670888918", "Lead", {
          content_name: "Editor",
        });

        window.gtag("event", "lead", {
          send_to: "UA-119404542-5",
          event_category: "main",
        });
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  onText1Changed = (event) => {
    try {
      this.setState({ text1: event.target.value });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onText1Selected = (text) => {
    try {
      this.setState({ text1: text });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onText2Changed = (event) => {
    try {
      this.setState({ text2: event.target.value });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onStyleChanged = (e, styleId) => {
    const target = e.target;
    const value = target.checked;
    if (value) {
      this.setState({
        ...this.state,
        selectedStyleId: styleId,
      });
    }
  };

  onMaterialChanged = (info) => {
    const {
      price,
      ratio,
      selectedMaterialId,
      selectedSizeId,
      selectedHangerId,
      selectedMaterialName,
      selectedHangerName,
      width: printWidth,
      height: printHeight,
    } = info;
    this.setState({
      price,
      ratio,
      selectedMaterialId,
      selectedSizeId,
      selectedHangerId,
      selectedMaterialName,
      selectedHangerName,
      printWidth,
      printHeight,
    });
  };

  onMakeOrderClick = (materialUpdateInfo) => {
    var state = null;
    if (materialUpdateInfo) {
      state = { ...this.state, ...materialUpdateInfo };
    } else {
      state = { ...this.state };
    }
    store.set("audioEditorStateDate", new Date());
    store.set("audioEditorState", state);

    const {
      text1,
      text2,
      price,
      selectedMaterialId,
      selectedSizeId,
      selectedHangerId,
      selectedMaterialName,
      selectedHangerName,
      selectedStyleId,
      printWidth,
      printHeight,
    } = state;

    const convertedDescription = {
      material: selectedMaterialName,
      size: selectedSizeId,
      hanger: selectedHangerName,
      style: selectedStyleId,
    };

    const product = {
      productType: "audio",
      text1,
      text2,
      price,
      material: selectedMaterialId,
      size: selectedSizeId,
      hanger: selectedHangerId,
      style: selectedStyleId,
      printWidth,
      printHeight,
      description: convertedDescription,
    };
    store.set("product", product);

    this.setState({ redirect: "cart" });
  };

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          push
          to={{
            pathname: this.state.redirect,
            // state: { product },
          }}
        />
      );
    }
    console.log("rendering: editor");
    return (
      <div class="d-flex flex-column-reverse flex-md-row  min-vh-100 ">
        <div class="bd-highlight d-flex flex-column flex-md-row">
          <EditorSidebar
            selectedStyleId={this.state.selectedStyleId}
            onStyleChanged={this.onStyleChanged}
            initialSelectedMaterialId={this.state.initialSelectedMaterialId}
            initialSelectedSizeId={this.state.initialSelectedSizeId}
            initialSelectedHangerId={this.state.initialSelectedHangerId}
            onMaterialChanged={this.onMaterialChanged}
            text1={this.state.text1}
            text2={this.state.text2}
            onText1Changed={this.onText1Changed}
            onText2Changed={this.onText2Changed}
            onText1Selected={this.onText1Selected}
            onMakeOrderClick={this.onMakeOrderClick}
            price={this.state.price}
          ></EditorSidebar>
        </div>
        <div class="bd-highlight d-flex flex-grow-1 align-items-stretch">
          <Map
            ref={this._map}
            text1={this.state.text1}
            text2={this.state.text2}
            styleId={this.state.selectedStyleId}
            ratio={this.state.ratio}
          ></Map>
        </div>
      </div>
    );
  }
}
export default withTranslation()(EditorComponent);
